/* eslint-disable react/require-default-props */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable no-undef */
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-array-index-key */
import PropTypes from "prop-types";
import Outclick from "react-outclick";
import { IconChevronDown } from "@tabler/icons";

const Sorter = ({
	show, onShow, onSelected, data, dataSelected,
}) => (
	<div className="sorter-desktop">
		<Outclick onOutsideClick={() => onShow(false)}>
			<div className="text" onClick={() => onShow(true)}>
				<p className="label">
					Sort By
					<span className="active">{dataSelected && data.filter((item) => dataSelected === item.id)[0].name}</span>
				</p>
				<span><IconChevronDown stroke="1" /></span>
			</div>
			<div className={`content ${show ? "show" : ""}`}>
				{
					data && data.map((item, idx) => (
						<p
							key={String(idx)}
							className={`item ${dataSelected === item.id ? "selected" : ""}`}
							onClick={() => {

								onSelected(item.id);
								onShow(false);

							}}
						>
							{item.name}
						</p>
					))
				}
			</div>
		</Outclick>
		<style jsx>
			{`
				.sorter-desktop {
					width: 210px;
					height: 40px;
					position: relative;
					-webkit-box-shadow:inset 0px 0px 0px 1px #DFE3E8;
					-moz-box-shadow:inset 0px 0px 0px 1px #DFE3E8;
					box-shadow:inset 0px 0px 0px 1px #DFE3E8;
					font-weight: 400;
					font-style: normal;
					font-size: 14px;
					line-height: 22px;
				}
				.sorter-desktop:hover {
					cursor: pointer;
				}
				.text {
					height: 40px;
					display: flex;
					align-items: center;
					justify-content: space-between;
					padding: 0 5px;
				}
				.text span {
					margin-top: 10px;
				}
				.text .label {
					margin: 0;
				}
				.text .label .active {
					font-weight: 600;
					margin-left: 5px;
				}
				.content {
					position: absolute;
					top: 15px;
					right: 0;
					left: 0;
					border-color: transparent #DFE3E8 #DFE3E8 #DFE3E8;
					border-style: solid solid solid solid;
					border-width: 0 1px 1px 1px;
					background: #fff;
					opacity: 0;
					visibility: hidden;
					transition: all .3s ease;
					z-index: 6;
				}
				.content .item {
					margin: 0;
					padding: 5px;
				}
				.content .item.selected {
					font-weight: 600;
				}
				.content.show {
					top: 38px;
					opacity: 1;
					visibility: visible;
				}
			`}
		</style>
	</div>
);

Sorter.propTypes = {
	show: PropTypes.bool.isRequired,
	onShow: PropTypes.func.isRequired,
	onSelected: PropTypes.func.isRequired,
	dataSelected: PropTypes.string,
	data: PropTypes.any.isRequired,
};

export default Sorter;
